/**
 * Safe numeric formatters — never crash on undefined/null/string inputs.
 *
 * The error log showed multiple Sentry hits for
 *   "TypeError: Cannot read properties of undefined (reading 'toFixed')"
 * on /dashboard. Use these helpers instead of raw `.toFixed()` whenever
 * the value comes from API data that might be missing.
 */

/** Coerce anything to a finite number, return null if not coercible. */
export function num(v) {
  if (v == null) return null;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Safe percent (0.123 -> "12.3%"). Returns fallback if value missing. */
export function fmtPct(v, digits = 1, fallback = "—") {
  const n = num(v);
  return n == null ? fallback : `${(n * 100).toFixed(digits)}%`;
}

/** Safe toFixed for already-percentage values (e.g. cap_rate=7.5 -> "7.5%") */
export function fmtNumber(v, digits = 1, fallback = "—") {
  const n = num(v);
  return n == null ? fallback : n.toFixed(digits);
}
